// Amber "internal note" surface shared by the handover-note thread block and the
// assignee-outcome banner. The theme has no warning CSS variables, so the palette
// lives here as the single source.
export const INTERNAL_NOTE_COLORS = {
    background: '#FDF6E3',
    border: '#EBD9A9',
    label: '#7A5B10',
};
